module.exports = __webpack_public_path__ + "static/media/logo.18a79b13.png";